<template>
  <div class="consultion">
    <!-- consultion modal -->
    <div id="consult-modal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body p-5 position-relative">
            <div class="row">
              <div class="col-12" v-if="product">您正在觀看的商品</div>
              <div class="col-12" v-else-if="consult">商品</div>
              <div class="col-12 mt-3" v-if="myProduct">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="consult-modal-img" :style="util.getImageStyle(myProduct.goodsImg)"></div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <div class="consult-modal-name">{{ myProduct.goodsName }}</div>
                    <div class="consult-modal-brand">{{ getBrandName(myProduct.brandId) }}</div>
                  </div>
                </div>
              </div>
              <!--div class="col-12 mt-3">
                <label for="consult-subject">主旨</label>
                <input id="consult-subject" type="text" class="form-control mt-2" :disabled="!!consult" v-model="myConsult.title">
              </div-->
              <div class="col-12 mt-3">
                <label for="consult-content">您的訊息</label>
                <textarea id="consult-content" class="form-control mt-2" rows="5" v-model="myConsult.textContent"></textarea>
              </div>
              <div class="col-12 mt-4">
                <button class="btn btn-dark w-100" data-bs-dismiss="modal" :disabled="!myConsult.textContent" @click="onConsultSubmitted">送出</button>
              </div>
            </div>
            <button type="button" class="btn p-5 btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
    <!-- consultion done modal -->
    <div id="consult-done-modal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body p-5 position-relative">
            <div class="row">
              <div class="col-12 mt-3 text-center consult-done-modal-title">已成功發送產品詢問單！</div>
              <div class="col-12 mt-4 text-center consult-done-modal-content">我們會盡快回覆您的問題。</div>
              <div class="col-12 mt-5"><button class="btn btn-dark w-100" data-bs-dismiss="modal">關閉</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import productApi from '@/api/product.js'
import userApi from '@/api/user.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ConsultionModal',
  props: {
    product: {
      type: Object,
      default: null
    },
    consult: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      myProduct: null,
      myConsult: {
        parentId: 0,
        type: 0,
        userId: 0,
        email: '',
        goodsId: 0,
        title: '',
        textContent: '',
        replyContent: '',
        questTime: 0,
        replyTime: 0,
        isFixed: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'authId',
      'getBrandName',
      'user'
    ]),
    util: function () {
      return util
    }
  },
  watch: {
    product: function (value) {
      if (value) {
        this.myProduct = value
      }
    },
    consult: function (value) {
      if (value) {
        this.myConsult.title = value.title
        this.apiGetProduct(value.goodsId)
      }
    }
  },
  mounted: function () {
    if (this.product) {
      this.myProduct = this.product
    }
    if (this.consult) {
      this.myConsult.title = this.consult.title
      this.apiGetProduct(this.consult.goodsId)
    }
  },
  methods: {
    ...mapMutations([
      'setAlert',
      'signOut'
    ]),
    apiGetProduct: function (id) {
      if (!id) {
        return
      }
      var self = this
      productApi.getProduct(id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.myProduct = rspData
      })
    },
    apiAddConsult: function () {
      if (!this.myConsult) {
        return
      }
      this.myConsult.userId = this.authId
      this.myConsult.email = this.user.email
      this.myConsult.goodsId = this.myProduct.goodsId
      this.myConsult.questTime = parseInt(new Date().getTime())
      this.myConsult.type = constant.CUSTOMER_SVC_TYPE.CONSULT
      this.myConsult.parentId = this.consult ? this.consult.id : 0
      var self = this
      userApi.addConsult(this.myConsult, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: '執行發生錯誤' })
          }
          return
        }
        var modal = new bootstrap.Modal(document.getElementById('consult-done-modal'))
        if (modal) {
          modal.show()
        }
        self.$emit('consult-submitted')
      })
    },
    onConsultSubmitted: function () {
      if (!this.myConsult.textContent) {
        this.setAlert({ type: constant.ALERT_TYPE.WARN, msg: '請填寫諮詢內容' })
        return
      }
      this.apiAddConsult()
    }
  }
}
</script>

<style scoped>
.consult-modal-img {
  width: 84px;
  height: 84px;
}
.consult-modal-brand {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.1rem;
}
.consult-modal-name {
  font-size: 1rem;
}
.btn-close {
  top: 0;
  right: 0;
  z-index: 1;
}
.consult-done-modal-title {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.3rem;
  font-weight: 700;
}
.consult-done-modal-content {
  font-weight: 500;
}
</style>
